<div class="captcha-wrapper">
    <h4 class="modal-title">{{'Modals.captchaTitle' | translate}}</h4>
    <span>{{'Modals.captchaDescription' | translate }}</span>
    <div class="captcha-container" id="recaptcha-container"></div>
</div>  